import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { Container } from "react-bootstrap";
import "./navigation-bar.scss";

function NavigationBarAtom(props) {
    const { children } = props;
    return (
        <Navbar bg="light" variant="light" className="text-body grey-grad">
            <Container fluid>
                <Nav className="me-auto text-uppercase text-body">
                    {children}
                </Nav>
            </Container>
        </Navbar>
    );
}

export default NavigationBarAtom;
